import { z } from 'zod';
const baseSchema = z.object({
    hhaPresent: z.string().min(1, 'required'),
    clinicianName: z.string().optional(),
    ptInterviewed: z.string().min(1, 'required'),
    observedCare: z.string().min(1, 'required'),
    caringAttitude: z.string().min(1, 'required'),
    confidentiality: z.string().min(1, 'required'),
    openCommunication: z.string().min(1, 'required'),
    followHHAPOC: z.string().min(1, 'required'),
    safeEffectiveCare: z.string().min(1, 'required'),
    infectionPrevention: z.string().min(1, 'required'),
    cleanEnvironment: z.string().min(1, 'required'),
    ptBenefittingHHAaid: z.string().min(1, 'required'),
    aidSameFrequency: z.string().min(1, 'required'),
    aidPlanUpdated: z.string().min(1, 'required'),
    aidPlanUpdatedComment: z.string().optional(),
});
export const hhaSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: z.preprocess((input, ctx) => {
            const payload = input;
            if (payload.hhaPresent === 'yes' && !payload.clinicianName) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please select a clinician',
                    path: ['clinicianName'],
                });
            }
            if (payload.aidPlanUpdated === 'yes' && !payload.aidPlanUpdatedComment) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter changes to the care plan',
                    path: ['aidPlanUpdatedComment'],
                });
            }
            return input;
        }, baseSchema),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
